import { Component, Input, ViewChild } from '@angular/core';
import { CredentialListVm } from '../../../../shared/generated/Administration/Models/Security/CredentialListVm';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RegisterAuthDeviceModalComponent } from '../register-auth-device-modal/register-auth-device-modal.component';
import { TableComponent } from '../../../../shared/table/table.component';
import { Subscription } from 'rxjs';
import { SystemMessageService } from '../../../../core/system-message/system-message-service';
import { SecurityService } from '../../../../core/security/security.service';
import { param } from '../../../../shared/http-params';

@Component({
    selector: 'pcg-user-multi-factor-authentication',
    templateUrl: './user-multi-factor-authentication.component.html',
    styleUrls: ['./user-multi-factor-authentication.component.scss'],
    standalone: false
})
export class UserMultiFactorAuthenticationComponent {

	credColumns = CredentialListVm.ColumnDefs;

	@Input() id = 0;
	@ViewChild(TableComponent, { static: true }) credentialTable: TableComponent<CredentialListVm>;

	// Used to keep track of subscriptions
	subscriptions = new Subscription();

	constructor(public modalService: NgbModal, private ms: SystemMessageService, private sec: SecurityService) { }

	/** Open the modal to add a new multi-factor auth device */
	openMultiFactorDeviceModal() {
		const modal = this.modalService.open(RegisterAuthDeviceModalComponent,
			// Reload the device list table when the modal is closed
			{ beforeDismiss: () => { this.credentialTable.ajaxReload(); return true; } });
			(<RegisterAuthDeviceModalComponent>modal.componentInstance).id = this.id;
	}

	/** Prompt user for password before continuing delete */
	deleteRecord(idParams: any) {
		this.sec.promptPassword(password => {
			this.subscriptions.add(this.ms.getHttpObservable(this, `api/Administration/Users/DeleteCredential?${param(idParams)}` +
				`&password=${encodeURIComponent(password)}`).subscribe(() => {
				this.credentialTable.ajaxReload();
			}));
		}, 'Are you sure you want to delete this credential? If so, verify your password below.',
		'Verify Password', true);
	}
}
